import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { carouselComponentMap, LayoutElementCarousel, LayoutElementCarouselProps } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/LayoutElementCarousel";
import { Container } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Container";
import { LayoutElementProvider, LayoutElementRendererData } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { LayoutElementCarouselTitleProps, Title } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Title";
export var LayoutElementBasedCarousel = function(props) {
    var className = props.className, elementCarouselClassName = props.elementCarouselClassName, titleClassName = props.titleClassName, rest = _object_without_properties(props, [
        "className",
        "elementCarouselClassName",
        "titleClassName"
    ]);
    var carouselProps = LayoutElementCarouselProps.build(rest);
    var titleProps = LayoutElementCarouselTitleProps.build(rest);
    var layoutElementProps = LayoutElementRendererData.build(rest);
    return /*#__PURE__*/ _jsx(LayoutElementProvider, _object_spread_props(_object_spread({}, layoutElementProps), {
        children: /*#__PURE__*/ _jsxs(StyledContainer, {
            className: className,
            children: [
                /*#__PURE__*/ _jsx(LayoutElementCarousel, _object_spread({
                    className: elementCarouselClassName
                }, carouselProps)),
                !props.hideTitle ? /*#__PURE__*/ _jsx(Title, _object_spread({
                    titleClassName: titleClassName
                }, titleProps)) : null
            ]
        })
    }));
};
var StyledContainer = styled(Container).withConfig({
    componentId: "sc-382e9682-0"
})([
    "display:flex;flex-direction:column-reverse;"
]);
export var isSupportedCarousel = function(type) {
    return carouselComponentMap.has(type);
};
